export var BuildingSource;
(function (BuildingSource) {
    BuildingSource[BuildingSource["SKETCH"] = 0] = "SKETCH";
    BuildingSource[BuildingSource["CUSTOM_OBS"] = 1] = "CUSTOM_OBS";
    BuildingSource[BuildingSource["SWISSTOPO"] = 2] = "SWISSTOPO";
    BuildingSource[BuildingSource["OSM"] = 3] = "OSM";
    BuildingSource[BuildingSource["VISUALIZER"] = 4] = "VISUALIZER";
})(BuildingSource || (BuildingSource = {}));
